import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { formatErrorMessage } from 'utils/util/error';
import SimplePage from '../Layout/Pages/SimplePage';

interface Props {
  error?: unknown;
  errorHeading?: string;
  errorMessage?: string | React.ReactNode;
}

const SimpleErrorPage: FC<Props> = ({ error, errorHeading, errorMessage }) => {
  const { formatMessage } = useIntl();
  return (
    <SimplePage
      title={
        errorHeading ||
        formatMessage({
          id: 'app.views.layout.error.error.default',
          defaultMessage: 'Oops! Something went wrong.',
        })
      }
      titleClassName="text-center"
    >
      {!!errorMessage && (
        <div className="text-center">
          <p>{errorMessage}</p>
        </div>
      )}
      {!!error && (
        <div className="text-center">
          <p>{formatErrorMessage(error)}</p>
        </div>
      )}
    </SimplePage>
  );
};

export default SimpleErrorPage;
